<div class="c-cms-form">
    <div class="form-desc">{{@field.extraConfig.htmlContent}}</div>
</div>